"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Dropdown_1 = require("../Dropdown");
var TimePickerPopover_1 = require("./TimePickerPopover");
var helpers_1 = require("../../helpers");
var controls_1 = require("./controls");
var useControlState_1 = require("../helpers/useControlState");
var keyCode_1 = require("../../helpers/keyCode");
var helpers_2 = require("./helpers");
var common_1 = require("../../common");
exports.TimePicker = helpers_1.createUIElement('TimePicker', function (_a, ref) {
    var className = _a.className, disabled = _a.disabled, value = _a.value, error = _a.error, _b = _a.size, size = _b === void 0 ? helpers_2.MIN_WIDTH_TIMEPICKER_CONTROL : _b, _c = _a.is12Hours, is12Hours = _c === void 0 ? false : _c, placeholder = _a.placeholder, texts = _a.texts, _d = _a.controlRenderer, controlRenderer = _d === void 0 ? controls_1.createDefaultTimePickerControl() : _d, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "disabled", "value", "error", "size", "is12Hours", "placeholder", "texts", "controlRenderer", "onChange", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var rootRef = react_1.useRef(null);
    var buttonRef = ref || rootRef;
    var uiTexts = __assign(__assign({}, helpers_2.DEFAULT_TEXTS), texts);
    var _e = useControlState_1.useControlState({
        onFocus: onFocus,
        onBlur: onBlur,
        rootRef: buttonRef
    }), focused = _e.focused, active = _e.active, activate = _e.activate, _f = _e.input, onFocusInput = _f.onFocus, onBlurInput = _f.onBlur, preventBlur = _e.preventBlur;
    var defaultPlaceholder = is12Hours ? 'HH:MM XM' : 'HH:MM';
    var control = Dropdown_1.useDropdown({
        offset: 1,
        ref: buttonRef,
        renderControl: function (_a) {
            var button = _a.button, isActive = _a.isActive, dropdownActions = _a.actions;
            var actions = {
                open: function () {
                    if (disabled || isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.show();
                    activate();
                },
                close: function () {
                    if (disabled || !isActive) {
                        return;
                    }
                    dropdownActions === null || dropdownActions === void 0 ? void 0 : dropdownActions.hide();
                    activate();
                }
            };
            return controlRenderer(__assign(__assign({}, rest), { className: "vm-TimePicker " + className, testId: rest['data-selector-id'], placeholder: placeholder || defaultPlaceholder, actions: actions, disabled: !!disabled, focused: focused,
                active: active, opened: isActive, size: size,
                value: value,
                is12Hours: is12Hours, error: !!error, texts: {
                    am: uiTexts.am,
                    pm: uiTexts.pm
                }, style: style, control: {
                    ref: button.ref,
                    onFocus: onFocusInput,
                    onBlur: onBlurInput,
                    onClick: onClick,
                    onMouseDown: function (e) {
                        e.stopPropagation();
                        actions.open();
                        onMouseDown === null || onMouseDown === void 0 ? void 0 : onMouseDown(e);
                    },
                    onMouseUp: onMouseUp,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onKeyDown: function (e) {
                        if (e.keyCode === keyCode_1.KeyCode.Space && !disabled) {
                            isActive ? actions.close() : actions.open();
                        }
                        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(e);
                    },
                    onKeyUp: onKeyUp,
                    onKeyPress: onKeyPress
                } }));
        },
        renderContent: function (_a) {
            var actions = _a.actions;
            return (react_1.default.createElement(TimePickerPopover_1.TimePickerPopover, { onMouseDown: preventBlur, value: value, is12Hours: !!is12Hours, onRequestClose: actions.hide, onSelect: onChange, texts: uiTexts }));
        },
        dropdownWidth: size === common_1.CONTROL_SIZE.full
            ? Dropdown_1.DROPDOWN_WIDTH.controlWidth
            : Dropdown_1.DROPDOWN_WIDTH.minControlWidthAndMaxXXL
    })[0];
    return control;
});
//# sourceMappingURL=TimePicker.js.map